import { PUBLIC_OFFER, PUBLIC_OFFER_COPY } from '../constants/publicOffer';

export function validatePublicOffer(value) {
  if (!value || ![value.trialMonths, value.freeMonthlyInvoices, value.freeInvoiceMaxLessons]
    .every((count) => Number.isSafeInteger(count) && count > 0)
    || ![value.monthly, value.yearly, value.expertMonthly].every((amount) => typeof amount === 'number'
      && Number.isFinite(amount) && amount > 0 && Number.isSafeInteger(Math.round(amount * 100))
      && Math.abs(amount * 100 - Math.round(amount * 100)) < Number.EPSILON * amount * 100)
    || typeof value.vat !== 'string' || !value.vat.trim()) return null;
  return Object.freeze({
    trialMonths: value.trialMonths, monthly: value.monthly, yearly: value.yearly, expertMonthly: value.expertMonthly,
    freeMonthlyInvoices: value.freeMonthlyInvoices, freeInvoiceMaxLessons: value.freeInvoiceMaxLessons, vat: value.vat,
  });
}

export function requirePublicOffer(value) {
  const offer = validatePublicOffer(value);
  if (!offer) throw new Error(PUBLIC_OFFER_COPY.unavailable);
  return offer;
}

export function serializePublicOffer(value) {
  return JSON.stringify(requirePublicOffer(value)).replace(/[<>&\u2028\u2029]/g,
    (character) => `\\u${character.charCodeAt(0).toString(16).padStart(4, '0')}`);
}

export function readPublicOfferSnapshot(documentSource) {
  if (!documentSource) return null;
  try {
    return validatePublicOffer(JSON.parse(documentSource.getElementById(PUBLIC_OFFER.snapshotId)?.textContent));
  } catch {
    return null;
  }
}

export function buildPublicOfferCopy(offer) {
  return {
    cta: offer ? PUBLIC_OFFER_COPY.cta(offer.trialMonths) : PUBLIC_OFFER_COPY.neutralCta,
    trial: offer ? PUBLIC_OFFER_COPY.trial(offer.trialMonths) : PUBLIC_OFFER_COPY.neutralTrial,
  };
}
